import AuthCard from "../components/AuthCard";

export default function AuthPage() {
  return <AuthCard />;
}
